function eitherz(left, right) {
  return {
    right,
    left,
    isLeft: left != undefined && left != null,
    isRight: right != undefined && right != null,
    rightOr: function (defaultRight) {
      return right || defaultRight;
    },
    leftOr: function (defaultLeft) {
      return left || defaultLeft;
    },
    fold: function (cbLeft, cbRight) {
      if (this.isRight) {
        cbRight(this.right);
      } else if (this.isLeft) {
        cbLeft(this.left);
      }
    },
    get: function () {
      return left != null ? left : right;
    },
  };
}

const either = async (method) => {
  try {
    const { right, left } = await method();

    return eitherz(left, right);
  } catch (err) {
    const left = {
      type: "error",
      content: "Ha ocurrido un error interno. Intentelo de nuevo",
      err,
    };
    return eitherz(left, null);
  }
};

export const right = (data) => ({ right: data });
export const left = (data) => ({ left: data });

export default either;
